import { render } from "./UserActivityLogSavePartial.vue?vue&type=template&id=e03ed9a4"
import script from "./UserActivityLogSavePartial.vue?vue&type=script&lang=js"
export * from "./UserActivityLogSavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script